import React from 'react';
import { DateTime } from 'luxon';
import { InputField, DateField } from '@atrocit/scl';

export default DateField;